export const MESSAGES = {
  error: 'Что-то пошло не так',
  errorTryLater: 'Что-то пошло не так, попробуйте позже',
  account: {
    deleted: 'Аккаунт удален',
  },
};
